import { DATA_AI_TWIN_DEMO_1 } from "./AiTwinDemo/305AiTwinDemo_1";
import { DATA_AI_TWIN_DEMO_2 } from "./AiTwinDemo/306AiTwinDemo_2";
import { DATA_AI_TWIN_DEMO_3 } from "./AiTwinDemo/307AiTwinDemo_3";
import { DATA_AI_TWIN_DEMO_4 } from "./AiTwinDemo/308AiTwinDemo_4";
import { DATA_AI_TWIN_DEMO_5 } from "./AiTwinDemo/309AiTwinDemo_5";
import { DATA_AI_TWIN_DEMO_6 } from "./AiTwinDemo/310AiTwinDemo_6";
import { DATA_AI_TWIN_DEMO_END } from "./AiTwinDemo/311AiTwinDemo_End";
import { DATA_INTRO_AI_TWIN_1 } from "./Introduction/301DataIntroAITWIN_1";
import { DATA_BENEFITS_AI_TWIN_1 } from "./Introduction/302DataIntroAITWIN_2";
import { DATA_BENEFITS_AI_TWIN_2 } from "./Introduction/303DataIntroAITWIN_3";
import { DATA_BENEFITS_AI_TWIN_3 } from "./Introduction/304DataIntroAITWIN_4";
import { DATA_BENEFITS_AI_TWIN_4 } from "./Introduction/312DataIntroAITWIN_6";
import { DATA_CHARACTERS_AI_TWIN } from "./Introduction/313DataCharactersAITWIN";

export const AI_TWIN_WORKFLOW = [
  { page: "AITWIN_301", type: "intro-template" as TemplateType, data: DATA_INTRO_AI_TWIN_1 },
  { page: "AITWIN_302", type: "benefits-template" as TemplateType, data: DATA_BENEFITS_AI_TWIN_1 },
  { page: "AITWIN_303", type: "benefits-template" as TemplateType, data: DATA_BENEFITS_AI_TWIN_2 },
  { page: "AITWIN_304", type: "benefits-template" as TemplateType, data: DATA_BENEFITS_AI_TWIN_3 },
  { page: "AITWIN_312", type: "benefits-template" as TemplateType, data: DATA_BENEFITS_AI_TWIN_4 },
  { page: "AITWIN_313", type: "characters-template" as TemplateType, data: DATA_CHARACTERS_AI_TWIN },
  { page: "AITWIN_305", type: "journey-two-template" as TemplateType, data: DATA_AI_TWIN_DEMO_1 },
  { page: "AITWIN_306", type: "journey-two-template" as TemplateType, data: DATA_AI_TWIN_DEMO_2 },
  { page: "AITWIN_307", type: "journey-two-template" as TemplateType, data: DATA_AI_TWIN_DEMO_3 },
  { page: "AITWIN_308", type: "journey-two-template" as TemplateType, data: DATA_AI_TWIN_DEMO_4 },
  { page: "AITWIN_309", type: "journey-two-template" as TemplateType, data: DATA_AI_TWIN_DEMO_5 },
  { page: "AITWIN_310", type: "journey-two-template" as TemplateType, data: DATA_AI_TWIN_DEMO_6 },
  { page: "AITWIN_311", type: "end-template" as TemplateType, data: DATA_AI_TWIN_DEMO_END },
];
